"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M11.814 6.036a.5.5 0 0 1 .372 0l2.764 1.106-3.153 1.401a.5.5 0 1 0 .406.914l4.043-1.797 3.44 1.376a.5.5 0 0 1 0 .928l-.686.274v4.847a1.5 1.5 0 0 1 1 1.415v1a1.5 1.5 0 0 1-3 0v-1a1.5 1.5 0 0 1 1-1.415v-4.447l-.864.346-.048.017c-1.25.5-1.943.775-2.636 1.05L12 13.03l-5.128-2.045-.045-.016-2.513-1.005a.5.5 0 0 1 0-.928z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m7.31 12.236.7 3.366a.5.5 0 0 0 .136.252L8.5 15.5l-.354.354h.001l.001.002.003.002.005.005.017.016.051.045q.065.057.183.14c.158.112.39.254.702.393.628.279 1.572.543 2.891.543s2.263-.264 2.89-.543c.313-.14.545-.28.703-.392a3 3 0 0 0 .234-.186l.017-.016.005-.005.003-.003s.002-.001-.352-.355l.354.354a.5.5 0 0 0 .135-.252l.702-3.366c-.795.318-1.332.531-1.87.745l-2.635 1.051a.5.5 0 0 1-.371 0z"
  })]
}), 'EducationFilled');
//# sourceMappingURL=index.js.map